export default __webpack_public_path__ + "static/media/04.a5d5c957.jpg";